module.exports = __webpack_public_path__ + "img/9_122.6e5909d4.png";